import React from "react";
import { node, string } from "prop-types";
import Block from "../../../Block";
import Paragraph from "../../../Paragraph";
import Heading from "../../../Heading";
import Link from "../../../Link";
import { Col, Container, Row } from "../../../Grid";
import Section from "../../../Section";
import { sxProps, sxPropTypes } from "../../../props/sx";
import { classes } from "../../../utils/classes";
import pureProps from "../../../utils/pureProps";

const ConvertFileFormatsSection = ({ children, className }) => {
	return (
		<Section className={classes(className)}>
			<Container>{children}</Container>
		</Section>
	);
};

ConvertFileFormatsSection.propTypes = {
	children: node.isRequired,
	className: string,
};

export const ConvertFileFormatsHead = ({ title, children }) => {
	return (
		<>
			<Row utility={{ justify: "center" }}>
				<Col>
					<Heading Tag="div" sx={{ fontSize: "xl", textAlign: "center" }}>
						{title}
					</Heading>
				</Col>
			</Row>
			{children && (
				<Row utility={{ justify: "center" }}>
					<Col sm={12} md={5} spacing={{ mt: 10 }}>
						<Paragraph sx={{ textAlign: "center" }}>{children}</Paragraph>
					</Col>
				</Row>
			)}
		</>
	);
};

ConvertFileFormatsHead.propTypes = {
	title: node.isRequired,
	children: node,
};

export const FileFormatsOptions = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }} spacing={{ mt: 12 }}>
			<Col sm={11} md={10}>
				<Row mx>{children}</Row>
			</Col>
		</Row>
	);
};

FileFormatsOptions.propTypes = {
	children: node.isRequired,
};

export const FileFormatsOptionsLinkWrapper = ({ sm = 12, md = 4, children }) => {
	return (
		<Col sm={sm} md={md}>
			{children}
		</Col>
	);
};

FileFormatsOptionsLinkWrapper.propTypes = {
	children: node.isRequired,
	sm: string,
	md: string,
};

export const FileFormatsOptionsLink = ({ size = "l", sx = { ...sxProps }, ...props }) => {
	return (
		<Block spacing={{ mb: 6 }}>
			<Link sx={{ fontSize: size, ...pureProps(sx) }} {...props} />
		</Block>
	);
};

FileFormatsOptionsLink.propTypes = {
	sx: sxPropTypes,
	...Link.propTypes,
};

export default ConvertFileFormatsSection;
